import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

import { MODULE } from '@modules/types';

import { Suspendable } from '@components';
import { ROUTES } from '@constants';

const ScheduledCampaigns = Suspendable(
  lazy(() =>
    import('@modules/scheduledCampaigns/controller/ScheduledCampaignsController').then(
      (module) => ({
        default: module.default,
      })
    )
  )
);

const Campaign = Suspendable(
  lazy(() =>
    import('@modules/scheduledCampaigns/submodules/scheduledCampaign/controller/ScheduledCampaignController').then(
      (module) => ({
        default: module.default,
      })
    )
  )
);

export const ScheduledCampaignRoutes: RouteObject[] = [
  {
    path: ROUTES.SCHEDULED_CAMPAIGNS.ROOT,
    element: <ScheduledCampaigns module={MODULE.SCHEDULED_CAMPAIGN} />,
  },
  {
    element: <Campaign mode="create" />,
    path: ROUTES.SCHEDULED_CAMPAIGNS.CREATE,
  },
  {
    element: <Campaign mode="edit" />,
    path: ROUTES.SCHEDULED_CAMPAIGNS.EDIT,
  },
  {
    element: <Campaign mode="clone" />,
    path: ROUTES.SCHEDULED_CAMPAIGNS.CLONE,
  },
];
